module.exports = "/virtual-football-league/img/video/clubs/germany/leverkusen.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/germany/leverkusen.png
// module id = 346
// module chunks = 4